import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { AppSidebar as NewSidebar } from '@/layouts/AppSidebar';
import { Sidebar as OriginalSidebar } from '@/components/uiKit/Sidebar';
import { diagnosticApi } from '@/store/api/diagnosticApi';
import { userApi } from '@/store/api/userApi';
import { locations } from '@/locations';
import { firebaseUserRequestingSelector, mfaExpiredSelector } from '@/store/store';
import { ScreenSpinner } from '@/components/shared/feedback/ScreenSpinner';
import { useAuth } from '@/providers/AuthProvider';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import { analytics } from '@/analytics';

const isNewSidebar = true;

export const AppWrapper = () => {
  const [userMustChangePassword, setUserMustChangePassword] = useState<boolean | null>(null);
  const { user, signOut } = useAuth();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const isFirebaseUserRequesting = useSelector(firebaseUserRequestingSelector);
  const isMfaExpired = useSelector(mfaExpiredSelector);

  useEffect(() => {
    if (localStorage.getItem('userMustChangePassword')) {
      setUserMustChangePassword(true);
    } else {
      setUserMustChangePassword(false);
    }
  }, []);

  useEffect(() => {
    if (userMustChangePassword) {
      navigate(locations.public.change);
    }
  }, [userMustChangePassword]);

  if (isMfaExpired) {
    signOut().then(() => {
      navigate(locations.public.login);
      dispatch(diagnosticApi.util.resetApiState());
      dispatch(userApi.util.resetApiState());
      analytics.track('User logged out');
    });
  }

  if (isFirebaseUserRequesting) {
    return <ScreenSpinner />;
  }

  if (!user && userMustChangePassword === false) {
    sessionStorage.setItem('redirectAfterLogin', location.pathname + '?' + location.search);
    return <Navigate to={locations.public.login} state={{ from: location }} replace />;
  }

  return (
    <>
      <div className="hidden xl:flex">{isNewSidebar ? <NewSidebar /> : <OriginalSidebar />}</div>
      <Outlet />
    </>
  );
};
